export default __webpack_public_path__ + "static/media/clock.d6a84773.svg";